/**
 * 供應商 create／update 寫入 payload。
 * addresses／contacts：replace-all；聯絡人編 lineNo（地址不送 lineNo，後端依送出順序保存）；同陣列 isDefault 僅保留第一筆 true。
 * 禁止送 status／巢狀 id；欄位對齊 be doc `docs/api/supplier/mutation-routes.md`。
 */
export function buildSupplierWritePayload(values, { updatedAt = null } = {}) {
  const payload = {
    code: values?.code,
    name: values?.name,
    chineseName: emptyToNull(values?.chineseName),
    englishName: emptyToNull(values?.englishName),
    taxIdNumber: emptyToNull(values?.taxIdNumber),
    homepage: emptyToNull(values?.homepage),
    phone: emptyToNull(values?.phone),
    fax: emptyToNull(values?.fax),
    remark: emptyToNull(values?.remark),
    addresses: mapRowsWithLineNo(values?.addresses, mapAddressForWrite),
    contacts: mapRowsWithLineNo(values?.contacts, mapContactForWrite),
  };

  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

export function mapSupplierDetailToForm(detail) {
  return {
    code: detail?.code ?? '',
    name: detail?.name ?? '',
    chineseName: detail?.chineseName ?? '',
    englishName: detail?.englishName ?? '',
    taxIdNumber: detail?.taxIdNumber ?? '',
    homepage: detail?.homepage ?? '',
    phone: detail?.phone ?? '',
    fax: detail?.fax ?? '',
    remark: detail?.remark ?? '',
    addresses: (detail?.addresses ?? []).map(mapAddressToForm),
    contacts: (detail?.contacts ?? []).map(mapContactToForm),
  };
}

export function createEmptyAddressRow() {
  return {
    addressType: '',
    postalCode: '',
    address: '',
    isDefault: false,
    remark: '',
  };
}

export function createEmptyContactRow() {
  return {
    name: '',
    department: '',
    title: '',
    phone: '',
    mobile: '',
    email: '',
    isDefault: false,
    remark: '',
  };
}

function emptyToNull(value) {
  if (value == null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

function mapRowsWithLineNo(rows, mapFn) {
  let defaultSeen = false;
  return (rows ?? []).map((row, index) => {
    const wantsDefault = Boolean(row?.isDefault);
    const isDefault = wantsDefault && !defaultSeen;
    if (isDefault) {
      defaultSeen = true;
    }
    return mapFn(row, (index + 1) * 10, isDefault);
  });
}

function mapAddressForWrite(row, _lineNo, isDefault) {
  return {
    addressType: emptyToNull(row?.addressType),
    postalCode: emptyToNull(row?.postalCode),
    address: String(row?.address ?? '').trim(),
    isDefault,
    remark: emptyToNull(row?.remark),
  };
}

function mapContactForWrite(row, lineNo, isDefault) {
  return {
    lineNo,
    name: String(row?.name ?? '').trim(),
    department: emptyToNull(row?.department),
    title: emptyToNull(row?.title),
    phone: emptyToNull(row?.phone),
    mobile: emptyToNull(row?.mobile),
    email: emptyToNull(row?.email),
    isDefault,
    remark: emptyToNull(row?.remark),
  };
}

function mapAddressToForm(row) {
  return {
    addressType: row?.addressType ?? '',
    postalCode: row?.postalCode ?? '',
    address: row?.address ?? '',
    isDefault: Boolean(row?.isDefault),
    remark: row?.remark ?? '',
  };
}

function mapContactToForm(row) {
  return {
    name: row?.name ?? '',
    department: row?.department ?? '',
    title: row?.title ?? '',
    phone: row?.phone ?? '',
    mobile: row?.mobile ?? '',
    email: row?.email ?? '',
    isDefault: Boolean(row?.isDefault),
    remark: row?.remark ?? '',
  };
}
